<template>
  <div class="merch" pad-b="run:backToHome">
    <div class="merch__wrap">
      <Navigation />
    </div>

    <div v-if="merchProducts" class="content">
      <BackToHome />
      <div class="main-product">
        <div
          class="main-product__img"
          :style="{
            backgroundImage: `url(${
              mainProduct.imagesLauncher
                ? mainProduct.imagesLauncher[0]
                : 'merch-product.png'
            })`,
          }"
        ></div>
        <div class="main-product__content">
          <span class="-decor">Merch</span>
          <h3 class="main-product__name -line">{{ mainProduct.name }}</h3>
          <span class="discount" v-if="mainProduct.discount">
            {{ mainProduct.discount }}% OFF
          </span>
          <div
            class="main-product__description"
            v-html="stripHtml(mainProduct.shortDescription, 300)"
          ></div>
          <div class="main-product__footer">
            <a
              :href="
                `${
                  mainProduct.link
                }?utm_source=launcher&utm_medium=merch&utm_content=${productSlug(
                  mainProduct.name
                )}`
              "
              class="btn --large"
              id="pad-merch-main"
              pad-start
              pad-up="go:#pad-home"
              pad-right="go:.swiper-slide-active a"
              pad-left="run:leaveWebView,left"
              pad-a="click"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="btn__stroke"></span>
              <span class="btn__label">{{ $t("buy_now") }}</span>
            </a>
            <div class="price">
              <span class="price-promo">{{ mainProduct.catalogPrice }}</span>
              {{ mainProduct.price }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="productsList" class="products-slider">
        <span class="-decor">{{ $t("other_products") }}</span>
        <swiper
          ref="merchSwiper"
          :options="swiperOptions"
          @ready="setSlideHeight"
          @resize="setSlideHeight"
          @slideChangeTransitionEnd="setSlideHeight"
        >
          <swiper-slide
            class="product"
            v-for="(product, index) in productsList"
            :key="index"
          >
            <div
              class="product__img"
              :style="{
                backgroundImage: `url(${
                  product.images[0] ? product.images[0] : '/merch-product.png'
                })`,
              }"
            ></div>
            <div class="product__content">
              <h4 class="product__name">
                {{ product.name }}
              </h4>
              <span class="discount" v-if="product.discount">
                {{ product.discount }}% OFF
              </span>
              <div
                class="product__description"
                v-html="stripHtml(product.shortDescription, 50)"
              ></div>
              <div class="price">
                <span class="price-promo">{{ product.catalogPrice }}</span>
                {{ product.price }}
              </div>
              <a
                :href="
                  `${
                    product.link
                  }?utm_source=launcher&utm_medium=merch&utm_content=${productSlug(
                    product.name
                  )}`
                "
                class="btn"
                :id="`pad-merch-product-${index}`"
                pad-right="go:#pad-back"
                :pad-up="
                  selectedProduct === 0 ? `go:#pad-home` : `run:swiperPrev`
                "
                pad-left="go:#pad-merch-main"
                pad-down="run:swiperNext"
                pad-a="click"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t("buy_now") }}</a
              >
            </div>
          </swiper-slide>
        </swiper>
        <div class="nav">
          <button class="nav__prev" id="pad-merch-prev" @click="prev">
            <iconArrowUp />
          </button>
          <button class="nav__next" id="pad-merch-next" @click="next">
            <iconArrowDown />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Navigation from "@/components/Navigation.vue";
import BackToHome from "@/components/ui/BackToHome.vue";
import iconArrowUp from "@/components/Icons/iconArrowUp.vue";
import iconArrowDown from "@/components/Icons/iconArrowDown.vue";
import Gamepad from "@/utils/gamepadInit";
import { truncate } from "@/utils/filters";
import slugify from "slugify";

export default {
  components: {
    Navigation,
    BackToHome,
    iconArrowUp,
    iconArrowDown,
  },

  data() {
    return {
      swiperOptions: {
        direction: "vertical",
        slidesPerView: 2,
      },
      selectedProduct: 0,
    };
  },

  computed: {
    ...mapState({
      merchProducts: (state) => state.merchProducts,
      game: (state) => state.game,
    }),

    mainProduct() {
      console.log(this.merchProducts);
      return this.merchProducts[0];
    },

    productsList() {
      return this.merchProducts.slice(1);
    },
    swiper() {
      return this.$refs.merchSwiper.$swiper;
    },
  },

  async created() {
    if (!this.merchProducts) {
      await this.$store.dispatch("getMerchProducts");
    }

    document.swiperPrev = this.padPrev;
    document.swiperNext = this.padNext;
    document.backToHome = this.backToHome;
  },

  methods: {
    stripHtml(value, length) {
      if (!value) {
        return "";
      } else {
        const cleanString = value.replace(/(<([^>]+)>)/gi, "");
        return truncate(cleanString, length);
      }
    },
    backToHome() {
      this.$router.push({ name: `${this.game}` });
    },
    setSlideHeight(swiper) {
      const wrapper = document.querySelector(".swiper-wrapper");
      const slides = swiper.slides;
      slides.forEach((slide) => {
        slide.style.height = "33vh";
      });
      wrapper.style.height = "66vh";
      swiper.update();
    },

    prev() {
      this.swiper.slidePrev();
    },

    next() {
      this.swiper.slideNext();
    },

    padPrev() {
      const secondLastProduct = this.merchProducts.length - 3;

      if (this.selectedProduct > secondLastProduct) {
        document.pad.focus(`#pad-merch-product-${this.swiper.activeIndex}`);
        this.selectedProduct = this.swiper.activeIndex;
      } else {
        this.swiper.slidePrev();
        document.pad.focus(`#pad-merch-product-${this.swiper.activeIndex}`);
        this.selectedProduct = this.swiper.activeIndex;
      }
    },

    padNext() {
      const lastProduct = this.merchProducts.length - 2;
      const secondLastProduct = this.merchProducts.length - 3;

      if (this.selectedProduct < secondLastProduct) {
        this.swiper.slideNext();
        document.pad.focus(`#pad-merch-product-${this.swiper.activeIndex}`);
        this.selectedProduct = this.swiper.activeIndex;
      } else {
        document.pad.focus(`#pad-merch-product-${lastProduct}`);
        this.selectedProduct = lastProduct;
      }
    },

    productSlug(name) {
      return slugify(name, { strict: true }).toLowerCase();
    },
  },

  mounted() {
    Gamepad();
  },
};
</script>

<style lang="scss" scoped>
.merch {
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;

  &__wrap {
    padding: 0 5vw;
  }
}

.content {
  display: flex;
  height: 100%;
  margin-top: 6vh;
  flex-grow: 1;
  // overflow: hidden;
  position: relative;
}

.discount {
  background-color: #fff;
  height: 26px;
  position: relative;
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: #272727;
  font-family: "Gilam SemiBold", sans-serif;
  padding: 0px 10px 0 40px;
  font-size: 14px;
  line-height: 26px;
  margin-bottom: 10px;
  width: fit-content;

  &::before {
    position: absolute;
    left: 0;
    content: "";
    height: 100%;
    width: 30px;
    background-color: #ffe177;
    border-radius: 5px 0 0 5px;
    background-image: url("~@/assets/img/svg/discount-icon.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 80%;
  }
}

.button-back {
  position: absolute;
  top: -17px;
  right: 0;
  z-index: 11;
}

.main-product {
  height: 100%;
  width: 60vw;
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  padding-bottom: 12vh;
  position: relative;
  background: $black;
  z-index: 1;

  &__img {
    position: absolute;
    top: calc(-6vh - 72px);
    left: 0;
    width: 100%;
    height: calc(100% + 6vh + 72px - 20vh);
    background-size: cover;
    background-position: center right;
    z-index: -1;

    &::before {
      content: "";
      position: absolute;
      bottom: -20vh;
      left: 0;
      width: 100%;
      height: 54vh;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 55%,
        rgba(39, 39, 39, 0) 100%
      );
      pointer-events: none;
    }
  }

  &__content {
    padding: 0 5vw 0 calc(5vw + 3.5rem);
  }

  &__name {
    color: $white;
    font-size: 26px;
    margin-bottom: 10px;

    &::before {
      left: -3.5rem;
    }
  }

  &__description {
    font-size: 14px;
    color: $white-60 !important;
  }

  &__footer {
    margin-top: 30px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .btn {
    margin-top: 0;

    &__label {
      font-size: 16px;
    }
  }
}

.price {
  color: $yellow;
  font-size: 26px;
  font-family: "Gilam SemiBold";
}

.price-promo {
  color: #9d9d9d;
  text-decoration: line-through;
  margin-right: 8px;
  font-size: 21px;
}

.products-slider {
  flex-grow: 1;
  height: 100%;
  position: relative;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 2;
  }

  &::before {
    background: linear-gradient(
      180deg,
      rgba(39, 39, 39, 0) 80%,
      rgba(39, 39, 39, 1) 100%
    );
  }

  &::after {
    background: linear-gradient(
      0deg,
      rgba(39, 39, 39, 0) 90%,
      rgba(39, 39, 39, 1) 100%
    );
  }

  .-decor {
    padding: 0 5vw;
    position: relative;
    z-index: 10;
  }
}

.nav {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: $yellow;
  width: 5vw;

  button {
    background: transparent;
    border: none;
    height: 7.4vh;
    cursor: pointer;
  }
}

.product {
  border-bottom: 1px solid $white-10;
  padding: 3.5vh 3.5vw;
  height: 33vh;
  position: relative;

  &__img {
    position: absolute;
    right: 5vw;
    bottom: 0;
    width: 15vw;
    height: 100%;
    background-size: contain;
    background-position: center;
  }

  &__content {
    width: 22vw;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &__name {
    color: $white;
    font-size: 18px;
    line-height: 1.2;
    margin-bottom: 10px;
    width: 80%;
  }

  &__description {
    display: none;
    width: 78%;
    font-size: 14px;
    color: $white-60 !important;
  }

  .btn {
    margin-top: auto;
  }
}

@media screen and (min-width: $screen-medium) {
  .product {
    &__description {
      display: block;
    }
  }
}
</style>

<style lang="scss">
.merch {
  .swiper-container {
    height: auto !important;
    overflow: visible !important;
  }
}
</style>
